(function () {
  var height = $(window).height();
  console.log(height);
  $('.qr-section').css('min-height', height + 'px');

  const options = {
    strings: [
      'La calidad en el software es algo que nos tomamos muy en serio y nuestras prácticas lo demuestran.^4000',
      '¡Desarrollamos software mantenible, robusto y escalable!^7000'
    ],
    typeSpeed: 80,
    fadeOut: true,
    loop: true
  };

  // init controller
  var controllerNavigation = new ScrollMagic.Controller();

  // change behaviour of controller to animate scroll instead of jump
  controllerNavigation.scrollTo(function (newpos) {
    TweenMax.to(window, 0.5, {scrollTo: {y: newpos}});
  });

  $("#main-header a.nav-link, #main-header #navbar-brand").click(function (e) {
    var id = $(this).attr("href");
    if ($(id).length > 0) {
      e.preventDefault();

      // trigger scroll
      controllerNavigation.scrollTo(id);

      // if supported by the browser we can even update the URL.
      if (window.history && window.history.pushState) {
        history.pushState("", document.title, id);
      }
    }
  });


  var t = new Typed('.typing', options);

  particlesJS.load('particles-js', '/particles.json', function () {
    console.log('callback - particles.js config loaded');
  });

  $("#ok-contacto-btn").click(function () {
    $('#success-mail').removeClass('bounceInDown');
    $('#success-mail').addClass('bounceOutUp');
  });

  $("#contacto-form").validate({
    submitHandler: function (form) {
      console.log("submitHandler");
      console.log($(form).serialize());
      $.post("sendMail.php", $(form).serialize())
        .done(function () {
          console.log("done");
          $('#success-mail').removeClass('bounceOutUp');
          $('#success-mail').addClass('animated bounceInDown');
          $(form).trigger("reset");
        })
        .fail(function () {
          alert("Algo salió mal, intenta de nuevo.");
        });
    },
    messages: {
      email: {
        required: "Por favor introduce tu dirección de correo para poder contactarte",
        email: "Formato de correo inválido"
      },
      phone: "Por favor introduce tu número de teléfono para poder contactarte",
      name: "Por favor dinos quien eres",
      business: "Por favor dinos de que empresa nos contactas",
      message: "Por favor dinos en que podemos ayudarte"
    }
  });


})();
